import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { getOwnerCommitteeStatusClass, OwnerCommitteeStatus } from "../../../ownercommitteeapi/entities";
import { OwnerCommitteeApi } from "../../../ownercommitteeapi";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";
import { DateUtil } from "@eres/core";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import OCRequestsListView from "../../../components/MyRequest/OCRequestsListView";
import OCRequestsGridView from "../../../components/MyRequest/OCRequestsGridView";
import { formatAppDate } from "@my-dld/utils/Utils";

interface Props extends RoutedViewProps {

}

interface State {
	isLoading: boolean;
	ocRequests: OwnerCommitteeStatus[];
}

class OwnerCommitteeRequests extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			ocRequests: [],
		};
	}

	componentDidMount() {
		this.loadOCRequests();
	}

	render() {
		const { isLoading, ocRequests } = this.state;
		return <ListGridDataView
			isLoading={ isLoading }
			dataAvailable={ ocRequests.length > 0 }
			title={ Strings.owner_committee }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }/>;
	}

	private renderListView = () => {
		const { ocRequests } = this.state;
		return <OCRequestsListView items={ ocRequests }/>;
	};

	private renderGridView = () => {
		const { ocRequests } = this.state;
		return <OCRequestsGridView items={ ocRequests }/>;
	};

	private loadOCRequests() {
		OwnerCommitteeApi.getRequestList( TabuProfile.getParticipantNumber() ).then( ( resp: any ) => {
			this.setState( { isLoading: false } );
			if ( resp.validationErrorsList && resp.validationErrorsList.length > 0 ) {
				showErrorMessage( OwnerCommitteeApi.getValidationError( resp.validationErrorsList ) );
			} else {
				this.setState( {
					ocRequests: resp.response ? resp.response.status : [],
				} );
			}
		} ).catch( reason => {
			this.setState( { isLoading: false } );
			showErrorMessage( reason );
		} );
	}
}

export function getOCReqNo( item: OwnerCommitteeStatus ) {
	return item.referenceId;
}

export function getOCReqDate( item: OwnerCommitteeStatus ) {
	const date = DateUtil.parseDate( item.submittedDate, "YYYY-MM-DDThh:mm:ss" );
	return formatAppDate( date, "en" );
}

export function getOCReqPropertyInfo( item: OwnerCommitteeStatus ) {
	const val = getLocalValue( item.propertyInfo );
	return val ? val : "";
}

export function getOCReqStatus( item: OwnerCommitteeStatus ) {
	const val = getLocalValue( item.registrationStatus );
	return val ? val : "";
}

export function getOCReqStatusClass( item: OwnerCommitteeStatus ) {
	return getOwnerCommitteeStatusClass( item );
}

export function getOCReqCommitteeStatus( item: OwnerCommitteeStatus ) {
	const val = getLocalValue( item.boardMemberStatus );
	return val ? val : "";
}

export default OwnerCommitteeRequests;
